export default __webpack_public_path__ + "static/media/era.55f32f90.ico";